import axios from "axios";
import React, { Suspense, useEffect, useState } from "react";
import { Helmet } from "react-helmet";
import TrackVisibility from "react-on-screen";
import Layout from "../components/Layout";
import Progress from "../components/Progress";
import Resume from "../components/Resume";
import Sectiontitle from "../components/Sectiontitle";
import Smalltitle from "../components/Smalltitle";
import Spinner from "../components/Spinner";

function Resumes() {
  const [skills, setSkills] = useState([]);
  const [workingExperience, setWorkingExperience] = useState([]);
  const [educationExperience, setEducationExperience] = useState([]);

  useEffect(() => {
    axios.get("/api/skills").then((response) => {
      setSkills(response.data);
    });
    axios.get("/api/experience").then((response) => {
      setWorkingExperience(response.data.workingExperience);
      setEducationExperience(response.data.educationExperience);
    });
  }, []);

  return (
    <Layout>
      <Helmet>
        <title>Resume - Febrian Adhi Pratama</title>
        <meta
          name="description"
          content="My resume"
        />
      </Helmet>
      <Suspense fallback={<Spinner />}>
        <div className="mi-skills-area mi-section mi-padding-top">
          <div className="container">
            <Sectiontitle title="My Skills" />
            <div className="mi-skills">
              <div className="row mt-30-reverse">
                {skills.map((skill) => (
                  <TrackVisibility
                    once
                    className="col-lg-6 mt-30"
                    key={skill.title}
                  >
                    <Progress title={skill.title} percentage={skill.value} />
                  </TrackVisibility>
                ))}
              </div>
            </div>
          </div>
        </div>
        <div className="mi-resume-area mi-section mi-padding-top mi-padding-bottom">
          <div className="container">
            <Sectiontitle title="Resume" />
            <Smalltitle title="Working Experience" icon="briefcase" />
            <div className="mi-resume-wrapper">
              {workingExperience.map((workingExp) => {
                const details = workingExp.details;

                let parsedDetails = details;

                if (details?.includes("•")) {
                  const parts = details
                    .split("•")
                    .map(d => d.trim())
                    .filter(Boolean);

                  parsedDetails = (
                    <>
                      <p>{parts[0]}</p>
                      <ul>
                        {parts.slice(1).map((item, i) => (
                          <li key={i}>{item}</li>
                        ))}
                      </ul>
                    </>
                  );
                } else if (/\d+\.\s/.test(details)) {
                  parsedDetails = (
                    <ol>
                      {details
                        .split(/\d+\.\s/)
                        .filter(Boolean)
                        .map((item, i) => (
                          <li key={i}>{item.trim()}</li>
                        ))}
                    </ol>
                  );
                }

                return (
                  <Resume
                    key={workingExp.id}
                    resumeData={{ ...workingExp, details: parsedDetails }}
                  />
                );
              })}
            </div>
            <div className="mt-30"></div>
            <Smalltitle title="Educational Qualifications" icon="book" />
            <div className="mi-resume-wrapper">
              {educationExperience.map((educationExp) => {
                let details = educationExp.details;

                // Replace "here: <URL>" with a clickable link
                const url =
                  "https://openlibrary.telkomuniversity.ac.id/home/catalog/id/161820/slug/identifikasi-komentar-toksik-dengan-bert.html";

                if (details.includes(url)) {
                  details = (
                    <p>
                      My final project was <em>'Toxic Comments Identification Using BERT'</em>.
                      {" "}My research paper can be read{" "}
                      <a href={url} style={{color: "#037fff"}} target="_blank" rel="noopener noreferrer">
                        here
                      </a>
                      .
                    </p>
                  );
                }

                return (
                  <Resume
                    key={educationExp.id}
                    resumeData={{ ...educationExp, details }}
                  />
                );
              })}
            </div>
          </div>
        </div>
      </Suspense>
    </Layout>
  );
}

export default Resumes;
